module.exports = __webpack_public_path__ + "static/figure_sjc-apps-573138ee5f7f1ccf3d763b23e18499e2.png";